import { FadeUp, MaskedLine } from "./Reveal";

const CHAPTERS = [
    {
        n: "01",
        title: "The afterthought",
        text: "Most Indian homes invest in the living room, the kitchen, the fa\u00e7ade \u2014 then settle for a bathroom that merely works. Yet it is the first room you enter each morning and the last one at night.",
    },
    {
        n: "02",
        title: "A daily ritual",
        text: "Hot water at the right pressure. Light that flatters the early morning. Warmth on a cold Bangalore day, and quiet you can hear yourself think in. Small comforts that change how a whole day begins.",
    },
    {
        n: "03",
        title: "Everything, considered",
        text: "Tiles, fittings, shower, geyser, lighting, storage, drainage \u2014 designed together as one experience, not assembled piece by piece. That is the difference between a bathroom that works and one that lives.",
    },
];

const Manifesto = () => (
    <section className="bg-mineral text-ink" data-testid="manifesto-section">
        <div className="mx-auto max-w-[1440px] px-5 sm:px-10 py-16 sm:py-24">
            <div className="grid gap-14 lg:grid-cols-[1fr_1.6fr] lg:gap-20">
                <div className="lg:sticky lg:top-28 self-start">
                    <FadeUp>
                        <p className="font-mono text-[10px] sm:text-xs tracking-[0.3em] uppercase text-sand mb-6">
                            Why bathrooms matter
                        </p>
                    </FadeUp>
                    <h2 className="font-serif font-light leading-[1.05] tracking-tight text-[clamp(2.2rem,4.5vw,4rem)]">
                        <MaskedLine>The room you</MaskedLine>
                        <MaskedLine delay={0.1}>
                            <em className="italic">never</em> designed.
                        </MaskedLine>
                        <MaskedLine delay={0.2}>Until now.</MaskedLine>
                    </h2>
                    <FadeUp delay={0.3}>
                        <p className="mt-8 max-w-md text-sm sm:text-base font-light leading-relaxed text-ink/70">
                            A good bathroom is a sanctuary &mdash; a place that refreshes you and quietly
                            makes every day feel a little more premium. Most homes don't prioritise it.
                            We built Bath & Beyond to change that.
                        </p>
                        <p className="mt-6 font-mono text-[10px] tracking-[0.3em] uppercase text-sand">
                            A Spaces by Samita venture &mdash; Bangalore
                        </p>
                    </FadeUp>
                </div>

                <div className="flex flex-col">
                    {CHAPTERS.map((c, i) => (
                        <FadeUp key={c.n} delay={i * 0.08}>
                            <div
                                className="group grid gap-4 border-t hairline-light py-7 sm:grid-cols-[80px_1fr] sm:gap-10 sm:py-10 transition-colors duration-500 hover:bg-white/60"
                                data-testid={`manifesto-chapter-${c.n}`}
                            >
                                <span className="font-mono text-sm text-sand pt-2">{c.n}</span>
                                <div>
                                    <h3 className="font-serif text-2xl sm:text-3xl font-normal mb-3 sm:mb-4">
                                        {c.title}
                                    </h3>
                                    <p className="max-w-xl text-sm sm:text-base font-light leading-relaxed text-ink/70">
                                        {c.text}
                                    </p>
                                </div>
                            </div>
                        </FadeUp>
                    ))}
                    <div className="border-t hairline-light" />
                </div>
            </div>
        </div>
    </section>
);

export default Manifesto;
